import { ClassesBuilder } from '@utilities';

const classesConfig = {
  restartButtonIcon: 'mr-2',
};

export default new ClassesBuilder(classesConfig);
